import { useEffect, useState } from 'react';

// Mode clair / sombre de tout le site. Le bouton est sur l'accueil ; le choix
// s'applique à <html data-theme="…"> et reste mémorisé dans le navigateur.
export const THEME_KEY = 'theme';

const readStored = () => {
    try {
        return localStorage.getItem(THEME_KEY) === 'dark';
    } catch {
        return false; // stockage bloqué (navigation privée…) : clair
    }
};

export const useDarkMode = () => {
    const [darkMode, setDarkMode] = useState(readStored);

    useEffect(() => {
        const theme = darkMode ? 'dark' : 'light';
        document.documentElement.dataset.theme = theme;
        try {
            localStorage.setItem(THEME_KEY, theme);
        } catch {
            // pas mémorisé, mais appliqué pour la visite en cours
        }
    }, [darkMode]);

    return [darkMode, setDarkMode];
};
